import React, { useCallback, useMemo, useState } from 'react';
import FluidButton from 'ui/FluidButton';
import { TextInput } from 'ui/TextInput';
import { useDispatch, useSelector } from 'react-redux';
import { setOtpEmailAction, requestOtpEmailRequestAction } from 'store/modules/otp/actions';
import { otpEmailSelector, sendOtpEmailRequestStatusSelector, sendOtpEmailErrorsSelector } from 'store/modules/otp/selectors';
import { ENetworkRequestStatus } from 'services/BackendApi';
import { isValidEmail } from 'utils/email';
import { useHistory, useRouteMatch } from 'react-router';

interface IOtpRouteParams {
  itemUuid: string;
}

export const OtpPage = () => {
  const history = useHistory();
  const match = useRouteMatch<IOtpRouteParams>();
  const { itemUuid } = match.params;
  const dispatch = useDispatch();
  const email = useSelector(otpEmailSelector);
  const requestStatus = useSelector(sendOtpEmailRequestStatusSelector);
  const [emailTouched, setEmailTouched] = useState(false);
  const [emailErrorMessage, setEmailErrorMessage] = useState<string | null>(null);

  const handleEmailChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    dispatch(setOtpEmailAction(e.target.value));
    setEmailTouched(true);
    if (emailTouched) {
      setEmailErrorMessage(
        value && !isValidEmail(value) ? 'Please enter a valid email address.' : null
      );
    }
  }, [emailTouched, dispatch]);

  const handleSend = useCallback(() => {
    dispatch(requestOtpEmailRequestAction(itemUuid, history));
  }, [dispatch]);

  const handleEmailBlur = useCallback(() => {
    setEmailTouched(true);
  }, [])

  return (
    <div
      className="w-[360px] px-[35px] py-6 bg-white rounded shadow-[0px_0px_1px_0px_rgba(15,23,42,0.06)] flex flex-col justify-start items-center gap-6"
    >
      <div className="justify-start text-black text-xl font-normal font-noe-display">One Time Password</div>
      <div className="self-stretch justify-center text-black text-base font-normal font-pt-sans leading-snug">
        Please, enter your email address to continue.
        <br />
        <br />
        If you're authorized to view this document, a password will be sent to your inbox shortly.
      </div>
      <label className='text-black text-base font-bold font-pt-sans w-full self-stretch'>
        E-mail
        <TextInput
          id='email'
          placeholder='youremail@email.com'
          value={email}
          onChange={handleEmailChange}
          type="email"
          onBlur={handleEmailBlur}
          errorMessage={emailErrorMessage}
        />
      </label>
      <FluidButton
        type='primary'
        className='flex-1 self-stretch'
        disabled={requestStatus === ENetworkRequestStatus.PENDING || !email || !!emailErrorMessage}
        isLoading={requestStatus === ENetworkRequestStatus.PENDING}
        onClick={handleSend}
      >
        Send
      </FluidButton>
    </div>
  );
}